import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import Message from '../Common/Message/Message';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import LoginForm from './LoginForm/LoginForm';
import './Login.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            login: {
                user: {
                    id: '',
                    username: '',
                    password: '',
                    facebook_access_token: '',
                    google_id_token: ''
                }
            },
            validation: {
                user: {
                    username: {
                        valid: null,
                        msg: ''
                    },
                    password: {
                        valid: null,
                        msg: ''
                    }
                }
            },
            isReadyToSubmit : false,
            googleButtonFaded: false,
            isDisabled: false,
            loggedOut: false,
            message: {
                title: '',
                content: '',
                type: ''
            },
        };
    }

    logOutUser = async () => {
        console.log(this.props.user);
        this.props.user.role && await this.props.emptyCartOnLogout();

        try {
            const clientLogoutResponse = await logout();
            localStorage.removeItem('client');
            localStorage.removeItem('defaultStarPrinter');
            console.log('Client logout response: ', clientLogoutResponse);
            this.props.logout();
            this.setState({ loggedOut: true });
        } catch (error) {
            console.log(error);
        }

        async function logout(data) {
            return await ApiRequest(`/auth/logout`, {
                method: 'POST'
            });
        }
    }

    loginUser = async (e) => {
        if (e !== undefined) {
            console.log(e);
            e.preventDefault();
        }
        
        this.setMessage('', '', 'loading');
        const data = {...this.state.login};

        this.props.user.role && await this.props.emptyCartOnLogout();

        try {
            const clientLoginResponse = await login(data);
            console.log('Client login response: ', clientLoginResponse);
            const clientStatusResponse = await getAuthStatus();
            console.log('Client logged status Response: ', clientStatusResponse);

            if(clientLoginResponse.data.authenticated){
                this.props.userLogin(clientLoginResponse.data);
            } else {
                this.setMessage(window.general_strings.msg.oops, strings.msg.error, 'error');
            }
        } catch (error) {
            console.log(error);
        }

        async function login(data) {
            let social = '';
            if(data.user.facebook_access_token !== '') {
                social = '/facebook';
            }
            if(data.user.google_id_token !== '') {
                social = '/google';
            }
            return await ApiRequest(`/auth/login${social}`, {
                method: 'POST',
                data: data.user
            });
        }

        async function getAuthStatus() {
            return await ApiRequest('/auth/status');
        }
    }

    handleChange = (e) => {
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        const name = e.target.name;
        const login = {...this.state.login};
        login[key][name] = value;
        this.setState({ login });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, key, name, validationRegEx, e);
        }
        this.validateAllRequiredFields();
    }

    validate = (value, key, name, validationRegEx, e) => {
        e.persist();
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value) && value !== '') {
            validation[key][name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[key][name]['valid'] = isValid;
        this.setState({ validation }, () => this.validateRequiredField(e));
    }

    validateRequiredField = (e) => {
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const key = e.target.attributes.getNamedItem('object').value;
            const name = e.target.name;
            const validation = { ...this.state.validation };
            validation[key][name]['msg'] = strings.errorRequired;
            validation[key][name]['valid'] = false;
            this.setState({ validation }, () => this.validateAllRequiredFields());
        }
    }

    getSum = (total, num) => {
        return total + num;
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let arrValidation = Object.keys(validation).map((k) => validation[k]);
        let i = arrValidation.map((i) => { 
            return Object.keys(i).map((k) => i[k]);
        })
        .map((i) => { 
            return i.filter((l) => { 
                return typeof(l.valid) !== 'undefined'; 
            }).length; 
        })
        .reduce(this.getSum);
        for (let type in validation) {
            for (let field in validation[type]) {
                if (validation[type][field]['valid']) {
                    i--;
                }
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
    }

    updateValidation = () => {
        const validation = { ...this.state.validation };
        for (let field in validation['user']) {
            validation['user'][field]['valid'] = true;
        }
        this.setState({ validation });
    }

    disableNoLongerRequiredFields = () => {
        let isDisabled = {...this.state.isDisabled};
        isDisabled = true;
        this.setState({ isDisabled });
        this.updateValidation();
    }

    facebookCallback = (response) => {
        const login = { ...this.state.login };
        login['user']['facebook_access_token'] = response.accessToken;
        this.setState({ login }, () => this.loginUser());
        this.disableNoLongerRequiredFields();
        this.validateAllRequiredFields();
    }

    googleCallback = (response) => {
        const login = { ...this.state.login };
        login['user']['google_id_token'] = response.tokenId;
        console.log('google response: ', response);
        this.setState({ login }, () => this.loginUser());
        this.googleButtonOpacityToggle();
        this.disableNoLongerRequiredFields();
        this.validateAllRequiredFields();
    }

    googleButtonOpacityToggle = () => {
        let googleButtonFaded = this.state.googleButtonFaded;
        googleButtonFaded = !googleButtonFaded;
        this.setState({ googleButtonFaded });
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    
    setLoginProperties = () => {
        this.setMessage('', '', '');
        const location = this.props.routeProps.location.pathname;
        if (location === '/logout') {
            this.logOutUser();
        }
        
        const params = this.props.routeProps.match.params;
        if (typeof (params.userid) !== 'undefined' && typeof (params.username) !== 'undefined') {
            const login = { ...this.state.login };
            login['user']['id'] = params.userid;
            login['user']['username'] = params.username;
            this.setState({ login });
        }
    }
    
    componentDidMount() {
        this.setMessage('', '', 'loading');
        this.props.userStatusReady && this.setLoginProperties();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userStatusReady !== this.props.userStatusReady) {
            this.setLoginProperties();
        }
    }

    render() {
        return ( 
            <form onSubmit={this.loginUser}>
                <div className="container">
                    <Message
                        message={this.state.message}
                    />
                </div>    
                <LoginForm 
                    params={this.props.routeProps.match.params}
                    login={this.state.login} 
                    handleChange={this.handleChange} 
                    validateRequiredField={this.validateRequiredField}
                    validation={this.state.validation} 
                    facebookCallback={this.facebookCallback}
                    googleCallback={this.googleCallback}
                    googleButtonFaded={this.state.googleButtonFaded}
                    googleButtonOpacityToggle={this.state.googleButtonOpacityToggle}
                    loginUser={this.loginUser}  
                    isDisabled={this.state.isDisabled}
                    isReadyToSubmit={this.state.isReadyToSubmit}
                    loggedOut={this.state.loggedOut}
                />
            </form>
        );
    }
}

Login.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.object
    })
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js